<template>
  <div>
    <div class="main-title">考试学员查询
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择考场"
              @change="search(searchForm)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索学员姓名或身份证"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchForm)">
              <el-button slot="append" @click="readSearchIdcard">读身份证</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属考场"
          width="100">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员姓名"
          width="80">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="170">
          <template slot-scope="scope">
            <span v-if="scope.row.idcard === searchForm.query" style="color: #ff9900;">{{ scope.row.idcard }}</span>
            <span v-else>{{ scope.row.idcard }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
          show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="ok(scope.row)">合格</el-button>
            <el-button style="color: red;" type="text" @click="ok(scope.row)">不合格</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
export default {
  mixins: [ListFunc],
  props: {
    user: Object
  },
  data () {
    return {
      sqlcode: 'exam_student_hjd',
      companyList: [],
      searchForm: {
        company_ids: [],
        query: ''
      },
      idcardReading: false
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    readSearchIdcard () {
      if(!this.idcardReading) {
        this.idcardReading = true
        this.$idcard.read().then(data => {
          this.idcardReading = false
          this.searchForm.query = data.code
          this.search(this.searchForm)
        }).catch((e) => {
          this.idcardReading = false
        })
      }
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/exam/StudentHJD.vue